import instance from "./instance";

export const getDHLQuote = () => {
  return async (dispatch, getState) => {
    dispatch({ type: "SET_SHIPPING_LOADING" });
    const address = getState().customers.address;
    const cart = getState().cart;
    const branch = getState().branch;
    const settings = getState().store.store.settings;
    if (!settings.enable_dhl && !settings.enable_dhl_v2) return;
    try {
      const res = await instance.post(
        settings.enable_dhl
          ? "/get_dhl_quote/"
          : "/get_international_delivery_quote/",
        {
          ...address,
          ...cart,
          ...branch,
          country_code: getState().currency.selected,
        }
      );

      if (res.data.result === false) {
        dispatch({ type: "SET_SHIPPING_ERROR", payload: true });
      }
      dispatch({ type: "FETCH_SHIPPING_DATA", payload: res.data });
    } catch (err) {
      console.log(err);
    }

    dispatch({ type: "SET_SHIPPING_LOADING" });
  };
};
export const getAramexRate = () => {
  return async (dispatch, getState) => {
    dispatch({ type: "SET_SHIPPING_LOADING" });
    const address = getState().customers.address;
    const cart = getState().cart;
    const branch = getState().branch;
    const settings = getState().store.store.settings;
    if (!settings.enable_aramex) return;
    try {
      const res = await instance.post("aramex/calculate_rate/", {
        ...address,
        ...cart,
        ...branch,
        country_code: getState().currency.selected,
      });
      if (res.data.data.HasErrors === true || res.data.success === false) {
        dispatch({ type: "SET_SHIPPING_ERROR_ARAMEX", payload: true });
      }
      dispatch({ type: "FETCH_SHIPPING_DATA", payload: res.data.data });
      dispatch({ type: "SET_SHIPPING_ERROR_ARAMEX", payload: false });
    } catch (err) {
      console.log(err);
      dispatch({ type: "SET_SHIPPING_ERROR_ARAMEX", payload: true });
    }

    dispatch({ type: "SET_SHIPPING_LOADING" });
  };
};
